import { Bell, Search, LogOut } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { useAuthStore } from '@/stores/authStore'
import { useSignOut } from '@/hooks/useAuth'
import { formatDate } from '@/lib/utils'

export function TopBar() {
  const { restaurant } = useAuthStore()
  const signOut = useSignOut()
  const today = formatDate(new Date())

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-stone-200 bg-white px-6">
      <div className="flex items-center gap-4">
        <p className="text-sm text-stone-500">{today}</p>
        {restaurant && (
          <span className="hidden sm:inline text-xs font-medium text-stone-400 bg-stone-100 px-2 py-0.5 rounded capitalize">
            {restaurant.subscription_tier}
          </span>
        )}
      </div>

      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon-sm" aria-label="Search">
          <Search size={16} />
        </Button>
        <Button variant="ghost" size="icon-sm" aria-label="Notifications" className="relative">
          <Bell size={16} />
          {/* Alert dot — wired to ai_alerts in Phase 2 */}
          <span className="absolute top-1 right-1 h-1.5 w-1.5 rounded-full bg-danger" />
        </Button>
        <Button variant="ghost" size="icon-sm" onClick={signOut} aria-label="Sign out">
          <LogOut size={16} />
        </Button>
      </div>
    </header>
  )
}
